import {useLanguage} from "./languageContext.ts";
import translations from './translations.json'

interface Translations {
    mainTitle: {
        highlight: string;
        subtitle: string;
    };
    chatInput: {
        firstMessagePlaceholder: string;
        placeholder: string;
    };
    chatHints: {
        internetIssue: string;
        internetIssueFirstMessage: string;
        securityIssue: string;
        securityIssueFirstMessage: string;
        maintenanceIssue: string;
        maintenanceIssueFirstMessage: string;
        cleaningIssue: string;
        cleaningIssueFirstMessage: string;
    };
    issueReportForm: {
        issue: string;
        successMessage: string;
        successSubtitleMain: string;
        successSubtitleLink: string;
        editButton: string;
        submitButton: string;
        titleFieldLabel: string;
        titleErrorMissing: string;
        descriptionFieldLabel: string;
        descriptionErrorMissing: string;
        locationFieldLabel: string;
        locationErrorMissing: string;
    };
}

export const TRANSLATIONS: Record<string, Translations> = translations as Record<string, Translations>;
const ENGLISH: Translations = TRANSLATIONS['en']

const useTranslations = () => {
    const language = useLanguage();

    return TRANSLATIONS[language.languageCode] ?? ENGLISH;
}

export default useTranslations